import Routable from "vuetify/lib/mixins/routable";
import { VIcon } from "vuetify/lib";

export default {
	name: "KLink",

	mixins: [ Routable ],

	props: {
		icon: String,
		ripple: {
			default: true,
			type: Boolean
		}
	},

	computed: {
		styles() {
			return {
				color: this.$vuetify.theme.currentTheme.link,
				cursor: "pointer",
				padding: "2px",
				textDecoration: "none",
				...this.$vnode.data.normalizedStyle
			};
		}
	},

	render() {
		const linkData = this.generateRouteLink();
		const LinkTag = linkData.tag;

		return <LinkTag
			class="d-inline-block"
			style={this.styles}
			{...linkData.data}
		>
			<div class="align-start d-flex">
				{this.icon && <VIcon
					class="d-flex mr-1"
					small
					style="color: inherit;">{this.icon}</VIcon>
				}

				<span class="d-flex">{this.$slots.default}</span>
			</div>
		</LinkTag>;
	}
};
